var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2963_12139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 64C124 97.1371 97.1371 124 64 124C30.8629 124 4 97.1371 4 64C4 30.8629 30.8629 4 64 4C97.1371 4 124 30.8629 124 64ZM40 64C40 77.2548 50.7452 88 64 88C77.2548 88 88 77.2548 88 64C88 50.7452 77.2548 40 64 40C50.7452 40 40 50.7452 40 64Z",
    fill: "#4B0082",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 64C124 78.305 118.889 92.1393 109.589 103.008C100.289 113.878 87.4109 121.066 73.2779 123.278L67.7112 87.7113C73.3644 86.8265 78.5154 83.951 82.2355 79.6034C85.9556 75.2557 88 69.722 88 64H124Z",
    fill: "#FFC91C",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 4C71.8793 4 79.6815 5.55195 86.961 8.56723C94.2405 11.5825 100.855 16.0021 106.426 21.5736C111.998 27.1451 116.417 33.7595 119.433 41.039C122.448 48.3185 124 56.1207 124 64L88 64C88 60.8483 87.3792 57.7274 86.1731 54.8156C84.967 51.9038 83.1992 49.258 80.9706 47.0294C78.742 44.8008 76.0962 43.033 73.1844 41.8269C70.2726 40.6208 67.1517 40 64 40V4Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2678 123.28C63.5182 124.804 53.5431 123.9 44.2264 120.648C34.9096 117.396 26.5387 111.896 19.8555 104.636L46.3422 80.2543C49.0155 83.1584 52.3638 85.3584 56.0905 86.6592C59.8173 87.9601 63.8073 88.3217 67.7071 87.712L73.2678 123.28Z",
    fill: "#FFD039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8265 104.604C13.1484 97.3391 8.36534 88.539 5.90102 78.9836C3.4367 69.4282 3.36723 59.4125 5.69874 49.8238L40.6795 58.3295C39.7469 62.165 39.7747 66.1713 40.7604 69.9934C41.7461 73.8156 43.6594 77.3356 46.3306 80.2417L19.8265 104.604Z",
    fill: "#FFD655"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2963_12139",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2963_12139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2963_12139",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircle);
export default __webpack_public_path__ + "static/media/yellow_circle.ee996dfef0b84ac9ed39c46282710b40.svg";
export { ForwardRef as ReactComponent };